import * as React from "react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { Experiment as Experiments, isVariantEnabled } from "src/components/utility/experiment";
import { TripsBexApiComponentProps } from "components/shared/BexApiWrapper/TripsBexApiWrapper";

import { TripsHero } from "@shared-ui/trips-lists";

export const TripsOverviewHero = ({ inputs: { flexContext } }: TripsBexApiComponentProps) => {
  const { Trip_Hero_Web, SDUI_Trips_Total_Throttle } = Experiments;

  const isTripsExperimentEnabled = isVariantEnabled(flexContext, Trip_Hero_Web);

  if (!isTripsExperimentEnabled) {
    return null;
  }

  return (
    <Experiment name={SDUI_Trips_Total_Throttle}>
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <div className="TripsOverviewHero" data-testid="trips-overview-hero">
          <TripsHero />
        </div>
      </ExperimentVariant>
    </Experiment>
  );
};

export default TripsOverviewHero;
